import { ComunicatorLogView } from "@/pages/ComunicatorPage";

export default function ComLogPage() {
  return (
    <div>
      <div className="sw-page-title">
        <h1>📬 Log Invii</h1>
        <div className="sw-breadcrumb">Home &gt; Log Invii</div>
      </div>
      <ComunicatorLogView />
    </div>
  );
}
